import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ApiRequestService, LogService, UseCase, Void } from '@prekog/common-ui';
import { Observable } from 'rxjs';
import { GetNewsletterSubscribersCountResponse } from './get-newsletter-subscribers-count.response';

@Injectable({ providedIn: 'root' })
export class GetNewsletterSubscribersCountUseCase extends UseCase<Void, Observable<GetNewsletterSubscribersCountResponse>> {
    private _apiRequestService = inject(ApiRequestService);
    private _emailBaseUrl = inject<string>('EMAIL_BACKEND_URL' as never);
    private _getNewsletterSubscribersCountUrl = '/admin/getNewsletterSubscribersCount';

    constructor(_logService: LogService, _http: HttpClient) {
        super(_logService, _http);
    }

    protected override executeBusinessLogic(): Observable<GetNewsletterSubscribersCountResponse> | void {
        return this._apiRequestService.sendRequest<object, GetNewsletterSubscribersCountResponse>(
            this._emailBaseUrl,
            {},
            true,
            this._getNewsletterSubscribersCountUrl
        );
    }
}
